import React, { useEffect, useState } from "react";
import "./Login.css";
import userLogo from "../../assets/images/userLogo.png";
import { useDispatch } from "react-redux";
import { adminLoginData } from "../../features/adminLogin/adminLoginSlice";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  useEffect(() => {
    const tokenData = localStorage.getItem("access_token");
    if (tokenData === false) {
      navigate("/admin/login");
    }
  }, []);
  const handleChange = (e, id) => {
    if (id === "username") {
      setusername(e.target.value);
    } else {
      setpassword(e.target.value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      username: username,
      password: password,
    };
    console.log(username, password);
    dispatch(adminLoginData(data))
      .then((res) => {
        const token = res.payload.data[0].accessToken;
        // console.log(token)
        if (token) {
          localStorage.setItem("access_token", token);
          navigate("/admin");
        } else {
          navigate("/admin/login");
        }
      })
      .catch((err) => {
        navigate("/admin/login");
      });
  };

  return (
    <div className="loginWrapper">
      <div className="designContainer"></div>
      <div className="loginModuleContainer">
        <div className="userLogoContainer">
          <img src={userLogo} alt="" />
        </div>
        <h2>Admin, Login</h2>
        <form className="loginForm">
          <label for="adminusername">USERNAME</label>
          <input
            type="text"
            id="adminusername"
            name="adminusername"
            value={username}
            onChange={(e) => {
              handleChange(e, "username");
            }}
          />
          <label for="adminPassword">PASSWORD</label>
          <input
            type="password"
            id="adminPassword"
            name="adminPassword"
            value={password}
            onChange={(e) => {
              handleChange(e, "password");
            }}
          />
          <button
            type="submit"
            className="loginButton"
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            LOGIN
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
